import { render } from "./UsageOverview.vue?vue&type=template&id=185adc48&scoped=true"
import script from "./UsageOverview.vue?vue&type=script&lang=js"
export * from "./UsageOverview.vue?vue&type=script&lang=js"

import "./UsageOverview.vue?vue&type=style&index=0&id=185adc48&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185adc48"]])

export default __exports__